/*
Mapsteuerung der rmDATA Geoweb.js
Hauptfunktionen:
Zoom auf andere Koordinaten
Laden der Gemeindenamen
Schalten der einzelnen Layer/Themen
 */
const mapnamebuerger = 'Networx_Explorer_Buergermeistereinstieg';
const mapnamebbe = 'Networx_Explorer_BE_Einstieg';
const gemeindenbuerger = 'GEMEINDEN_EXTERN';
const gemeindenbe = 'GEMEINDEN_BE_EXTERN';
const foerderbuerger = 'FOERDERPROJEKT_EXTERN';
const foerderbe = 'FOERDERPROJEKT_BE_EXTERN';
var loaded = 0;
var mode = "BUERGER"
var bear = "Bearer ";
var gw = null; // geoweb Objekt
var infrastruktur = null;
var foundadresses = null;
const idsofappliedthemes = [];
var Bookmarks = {}

var ko = {
    observable: function (param) {
        // workaraound to simulate knockout
        // => knockout have to be removed from the geoweb api
        return function () {
            return false;
        }
    }
}

//Login Methode zum Inventory Manager um Daten wie Gemeinde abfrgen zu können
export function Testlogin() {
    return new Promise(function (resolve, reject) {
        $.ajax({

            // Our sample url to make request
            url:
                'https://kbb-bgld.rmdatacloud.com/service/token',

            // Type of Request
            type: "POST",
            contentType: "application/x-www-form-urlencoded",
            crossDomain: true,
            beforeSend: function (xhr, settings) {

                xhr.setRequestHeader("Authorization", bear);
                xhr.setRequestHeader("Azurelogin", true);

            },
            data: "grant_type=password&username=kartenapi%40rmdata.at&password=JFhRnahhMAG9gywNWiU9MAPywrX6g1iYc7biG2wLwQMI9j8%2BIyTFFkIBhAHJoT7l9czLx3cdx2xh34wqt9MW0A%3D%3D",


            success: function (data) {
                bear = "Bearer " + data.access_token;
                resolve(data);
            },

            // Error handling
            error: function (error) {
                resolve(error);
            }
        });
    });
}

//Init Funktion der Karte anschließender Zoom auf Eisenstadt in Landeskoordinaten 34
export function myInit(initmode) {
    mode = initmode;
    if (loaded > 0)
        return;
    loaded = 1;
    rmdata.InitPublicMapUser("https://kbb-bgld.rmdatacloud.com/service/api").then(function (bear) {
        rmdata.InitAPIv3(bear, "https://kbb-bgld.rmdatacloud.com/service/api/out/rmdata.api.js", "")
            .then(function (x) {
                setTimeout(async () => {
                    gw = new rmdata.GeoWeb("myMap", "loaderele");

                    gw.EventHub.on("MAPINITIALIZED", function () {
                        var intervalHandle = setInterval(async function () {

                            if (IsMapReady()) {
                                gw.GetBookmarks()
                                    .then(function (bookmarks) {

                                        bookmarks.forEach(function (bookmark) { // loop through all elements
                                            Bookmarks[bookmark.Name] = bookmark.Id;
                                        });
                                    });


                                clearInterval(intervalHandle);

                                //Eisenstadt LK34
                                window[0] = 6646; //left
                                window[1] = 296924;//bottom
                                window[2] = 19550; //right
                                window[3] = 306279; //top
                                gw.ZoomExtent(window);
                                ApplyTheme("Bandbreiten", true);

                            }

                        }, 500);
                        var window = [];


                        gw.EventHub.on("SELECTIONCHANGED", function (col) {

                            var overlayclone = gw.renderer.map.getOverlays().getArray().slice(0);

                            overlayclone.forEach(overlay => {
                                gw.renderer.map.removeOverlay(overlay);
                            });

                            if (col.SelectedFeatures.length > 0) {
                                var geoJsonData = new Object();
                                geoJsonData.features = new Array();
                                geoJsonData.type = "FeatureCollection";
                                geoJsonData.features = col.SelectedFeatures;

                                var features = (new rmdata.GeoJSON()).readFeatures(geoJsonData);

                                gw.ShowPlacemarks(features, false);

                                $('.ol-popup').removeClass('default');
                                $('.ol-popup').addClass('black shadow');

                            }

                        });
                    });
                    let mapname = mapnamebuerger;
                    if (mode === "BE")
                        mapname = mapnamebbe;
                    await gw.InitMapByNameV2(mapname);

                }, 1000);

            });
    });
}

function showbookmark(bookmarkName) {
    gw.ShowBookmark(Bookmarks[bookmarkName]);
}

//Query gegen den rmDATA Inventory Manager um Koordinaten oder Gemeindenamen zu bekommen.
function SearchWithParameter(queryname, paramname, param, withparameter) {
    let selecttag = document.getElementById("searchedadress");
    let d;
    if (withparameter > 0)
        d = "{'" + paramname + "': '" + param + "'}"
    return new Promise(function (resolve, reject) {
        $.ajax({

            // Our sample url to make request
            url:
                'https://kbb-bgld.rmdatacloud.com/service/api/InventoryExternal/AssetDBs/93ac81b3-f63e-4e55-8302-ec5d7bd0770d/ExecuteQuery/' + queryname + '/ByInternalName',

            // Type of Request
            type: "POST",
            contentType: "application/json",
            crossDomain: true,
            beforeSend: function (xhr, settings) {

                xhr.setRequestHeader("Authorization", bear);

            },

            data: d,


            // Function to call when to
            // request is ok
            success: function (data) {

                resolve(data);
            },

            // Error handling
            error: function (error) {
                resolve(error)
            }
        });
    });

}

export function ZoomExtent(param) {
    var window = [];
    window[0] = param[0]; //left
    window[1] = param[5];//bottom
    window[2] = param[2]; //right
    window[3] = param[1]; //top
    gw.ZoomExtent(window);


}

export function SearchGemeinden() {

    let query = gemeindenbuerger;
    if (mode === "BE")
        query = gemeindenbe;

    return SearchWithParameter(query, undefined, undefined, 0);
}

export function SearchAnbieter(gemeinde) {

    return SearchWithParameter("GEMEINDE_ANBIETER_EXTERN", "Gemeinde", gemeinde, 1);
}

export function SearchFoerderprojekte(gemeinde) {
    let query = foerderbuerger;
    if (mode === "BE")
        query = foerderbe;
    return SearchWithParameter(query, "Gemeinde", gemeinde, 1);
}


//Anzeigen der einzelnen Themen (Jedes Thema entspricht dabei einen eigenen Layer)
export function ApplyTheme(themename, visible) {
    let theme = gw._mapcontext._ThemeNamesExtended.find((element) => element.name == themename);
    if (theme) {
        if (visible) {
            gw.ApplyTheme(theme, idsofappliedthemes, null);
            idsofappliedthemes.push(theme.id);
        } else {
            gw.RemoveTheme(theme, idsofappliedthemes, null);
            idsofappliedthemes.splice(idsofappliedthemes.indexOf(theme), 1);
            if (idsofappliedthemes.length == 0) {
                let theme = gw._mapcontext._ThemeNamesExtended.find((element) => element.name == "Default");
                gw.ApplyTheme(theme, idsofappliedthemes, null);
                idsofappliedthemes.push(theme.id);
            }
        }
    }
}

//Prüffunktion ob die Map vollständig geladen ist.
function IsMapReady() {

    if (gw && gw.ChangeSet && gw.GetMapContext().MapId && gw.Renderer.map && gw.Renderer.map.renderComplete_) {

        return true;

    } else

        return false;

}
